/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Button, { type ButtonProps } from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import { Grid } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	root: {
		gridAutoColumns: '1fr',
	},
});

type ButtonGroupProps = {
	onChange?(value: string): void;
	options: Array<{ value: string; label: string; iconBefore?: ButtonProps['iconBefore'] }>;
	selected: string;
	testId?: string;
	// eslint-disable-next-line @repo/internal/react/consistent-props-definitions
	labelId: string;
};

/**
 * __Button group__
 *
 * A group of buttons within the appearance controls form, in a grid layout.
 */
const ButtonGroup: ({
	onChange,
	options,
	selected,
	labelId,
	testId,
}: ButtonGroupProps) => JSX.Element = ({
	onChange,
	options,
	selected,
	labelId,
	testId,
}: ButtonGroupProps) => {
	return (
		<Grid
			columnGap="space.050"
			autoFlow="column"
			xcss={styles.root}
			role="radiogroup"
			testId={testId}
			aria-labelledby={labelId}
		>
			{options.map(({ value, label, iconBefore }) => (
				<Button
					key={value}
					isSelected={selected === value}
					onClick={() => onChange?.(value)}
					iconBefore={iconBefore}
					role="radio"
					aria-checked={selected === value}
				>
					{label}
				</Button>
			))}
		</Grid>
	);
};

export default ButtonGroup;
